import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ruleSectionLabel' })
export class RuleSectionLabel implements PipeTransform {
	/**
	 * Format rule section into a legible label
	 */
	transform(value: string): string {
		let newValue = '';
		switch (value.toLocaleLowerCase()) {
			case 'comps':
				newValue = 'Comp Grid';
				break;
			case 'pdfreview':
				newValue = 'PDF Review';
				break;
			case 'subject|characteristics':
				newValue = 'Subject';
				break;
			case 'neighborhood|market':
				newValue = 'Neighborhood';
				break;
			case 'salesapproach':
				newValue = 'Sales Approach';
				break;
			case 'costapproach':
				newValue = 'Cost Approach';
				break;
			case 'overview|reconciliation':
				newValue = 'Overview or Reconciliation';
				break;
			case 'photoreview':
				newValue = 'Photo Review';
				break;
			case 'incomeapproach':
				newValue = 'Income Approach';
				break;
			case 'subject|pdfreview':
				newValue = 'Subject or PDF Review';
				break;
			case 'improvements|pdfreview':
				newValue = 'Improvements or PDF Review';
				break;
			case 'virtualtour':
				newValue = 'Virtual Tour';
				break;
			default:
				newValue = value;
				break;
		}
		return newValue;
	}
}
